import { Flex, Text, Icon } from '@/_components';
import type { QuestionnaireListItemProps } from './QuestionnaireListItem.types';
import type { FC } from 'react';
import Link from 'next/link';
import styles from './QuestionnaireListItem.module.css';

export const QuestionnaireListItem: FC<QuestionnaireListItemProps> = ({
  isCompleted,
  isPreview,
  companyHash,
  questionnaireId,
  id,
  name,
}) => {
  const sectionLink: string = isPreview
    ? `/preview/${companyHash}/questionnaire/${questionnaireId}?sectionId=${id}`
    : `/questionnaire/${companyHash}/?questionnaireId=${questionnaireId}&sectionId=${id}`;

  return (
    <Flex isYCentered={true} gap={4}>
      <Icon
        size={24}
        className={isCompleted ? 'text-success' : 'text-secondary'}
        name={isCompleted ? 'check-circle-filled' : 'check-circle'}
      />

      <Text type="small" className={styles.questionnaireListItem}>
        <Link href={sectionLink}>{name}</Link>
      </Text>
    </Flex>
  );
};
